import { Component, OnInit, Input, OnChanges, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos, Preguntas, Contacto, PreguntasSAES } from '../../components/common/utils/entities/util_entity';
import { EncuestaSaesComponentService } from "./EncuestaSaes.service";
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription'; //<== added this


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'Encuesta',
    templateUrl: 'EncuestaSaes.template.html'
})
@Injectable()
export class EncuestaSaesComponent implements OnInit {    
    codigosiniestro: number;
    codigopregunta: number;
    showLoader: string;
    preguntasaes: PreguntasSAES[];
    contacto: Contacto;
    
    private subscription: Subscription = new Subscription();
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private EncuestaSaeservice: EncuestaSaesComponentService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService
    ) {      

        this.preguntasaes = new Array<PreguntasSAES>();
        this.contacto = new Contacto();
    }
    ngOnInit(): void {
        
        
        this.showLoader = "sk-loading";
       this.contacto.ArqRes1=0;
       this.contacto.ArqRes2=0;
     
        this.route.params.subscribe(params => {
            this.codigosiniestro=params['idsiniestro'];
           // this.codigopregunta=params['idpregunta'];
             if (this.codigosiniestro != null) {

               this.EncuestaSaeservice.validacionEncuestaSaes(this.codigosiniestro).subscribe(
                        rst => {
                            
                            if(rst==="false")
                            {
                               
                                    this.EncuestaSaeservice.ConsultarPreguntas(this.codigosiniestro).subscribe(
                                        result => {
                                            this.preguntasaes = result;
                                            this.showLoader = "";
                                            this.preguntasaes.forEach(element => {
                                                element.IdSiniestro=this.codigosiniestro;
                                            });
                                            
                                        },
                                        error => {
                                            swal({
                                                title: 'Error',
                                                text: "Lo sentimos hubo un error, por favor intente nuevamente",
                                                type: 'error'
                                            }).then((function(){
                                                this.router.navigate("https://www.tecniseguros.com.ec/");
                                            }).bind(this));
                                            this.showLoader = "";
                                        });
                               
                            }
                            else
                            {
                                swal({
                                    title: 'Tecniseguros',
                                    text: "Lo sentimos, sus preguntas ya fueron contestadas.",
                                    type: 'warning'
                                }).then((function(){
                                    window.location.href = "http://www.tecniseguros.com.ec"
                                }).bind(this));
                            }
                            this.showLoader = "";
                        },
                        error => {
                            swal({
                                title: 'Error',
                                text: "Lo sentimos hubo un error, por favor intente nuevamente",
                                type: 'error'
                            }).then((function(){
                                window.location.href = "http://www.tecniseguros.com.ec"
                            }).bind(this));
                            this.showLoader = "";
                        });
               
            }
        });
        

       
       
    }
    ngOnDestroy(){ //<== added this
        this.subscription.unsubscribe();
    }
    asignarpregunta(pregunta:PreguntasSAES,res:number){
        this.preguntasaes.forEach(element => {
           
            if(element.Codpregunta==pregunta.Codpregunta){
                element.res1=false;
                element.res2=false;
                element.res3=false;
                element.res4=false;
                element.res5=false;
                switch(res) { 
                    case 1: { 
                        element.res1=true;
                       break; 
                    } 
                    case 2: { 
                        element.res2=true;
                       break; 
                    } 
                    case 3: { 
                        element.res3=true;
                        break; 
                     } 
                     case 4: { 
                        element.res4=true;
                        break; 
                     } 
                     case 5: { 
                        element.res5=true;
                        break; 
                     } 
                 } 
                    
                }
        });
    }

    GuardarPreguntasSaes() {
        
        let validacion=true;
        this.preguntasaes.forEach(element => {
            //console.log(element.res1+""+element.res2+""+element.res3+""+element.res4+""+element.res5);
            if(element.res1==false &&
                element.res2==false &&
                element.res3==false &&
                element.res4==false &&
                element.res5==false){
                   
                    validacion=false;
                    swal({
                        title: 'Advertencia',
                        text: "Por favor debe selecionar un opcion en cada pregunta",
                        type: 'warning'
                    }).then((function(){
                       // window.location.href = "http://www.tecniseguros.com.ec"
                    }).bind(this));
                    return;
                }
        });


if(validacion){
        this.EncuestaSaeservice.GuardarPreguntas(this.preguntasaes).subscribe(
            result => {
                console.log(result);
                if(result==true){
                    
                    swal({
                        title: 'Tecniseguros',
                        text: "Muchas gracias, sus preguntas fueron ingresadas correctamente.",
                        type: 'success'
                    }).then((function(){
                        window.location.href = "http://www.tecniseguros.com.ec"
                    }).bind(this));
                }
                
                this.showLoader = "";
            },
            error => {
                swal({
                    title: 'Error',
                    text: "Lo sentimos hubo un error, por favor intente nuevamente",
                    type: 'error'
                }).then((function(){
                    window.location.href = "http://www.tecniseguros.com.ec"
                }).bind(this));
                this.showLoader = "";
            });
        }
    }
    
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/EncuetasSAES/EncuestaSaes.component.ts